var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"bg-black column justify-center",attrs:{"view":"hHh lpR fFf"}},[_c('WelcomeInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }